import React from "react";

import { toHumanRelativeTimeFromNow } from "../../../lib/utils/relative_time";
import { formatAmount } from "../landing_utils";
import { SimilarRecord } from "../RecordCardShelf";

import css from "./SimilarTenders.module.scss";

type Props = {
  similar_records: SimilarRecord[];
};

export default function SimilarTenders({ similar_records }: Props) {
  return (
    <div className={css.similarTenders}>
      <h3>Explore similar pre-tenders, open or awarded contracts</h3>
      <p>
        Browse open tenders, recent contract awards and upcoming contract expiries that match
        similar CPV codes.
      </p>
      <div className={css.records}>
        {similar_records.map((record) => (
          <div className={css.recordCard} key={record.guid}>
            <div className={css.recordCardHeader}>
              <div className={css.awardedRow}>
                <div className={css.dot} /> <p className={css.awarded}>Awarded</p>
              </div>
              <h4>
                <a href={record.href}>{record.name}</a>
              </h4>
            </div>
            <p className={css.buyer}>{record.buyers[0].name}</p>
            <p className={css.amount}>{formatAmount(record.value, record.currency ?? null)}</p>
            <p className={css.date}>Published {toHumanRelativeTimeFromNow(record.publish_date)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
